import { Dropdown } from 'antd'

export type Placement = Exclude<
  (typeof Dropdown)['defaultProps'],
  undefined
>['placement']

export const calcMenuPositionByRect = (rect: DOMRect) => {
  const browserRect = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
  }
  const position: {
    dimension: {
      top: number | string
      bottom: number | string
      left: number | string
      right: number | string
    }
    placement: Placement
  } = {
    dimension: {
      top: 'auto',
      bottom: 'auto',
      left: 'auto',
      right: 'auto',
    },
    placement: 'bottomLeft',
  }

  if (browserRect.height / 2 < rect.top) {
    position.dimension.bottom = browserRect.height - rect.top + 10
    position.placement = 'top'
  } else {
    position.dimension.top = rect.top + rect.height + 10
    position.placement = 'bottom'
  }

  if (browserRect.width - (rect.left + rect.width) < 250) {
    position.dimension.right = browserRect.width - (rect.left + rect.width)
    position.placement += 'Right'
  } else {
    position.dimension.left = rect.left
    position.placement += 'Left'
  }

  return position
}

export const calcMenuPositionByElement = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect()
  return calcMenuPositionByRect(rect)
}

export const calcMenuPosition = calcMenuPositionByElement
